import { IField, FieldType } from '@esri/arcgis-rest-types';

export function arcgisAttributesToProperties(
  attributes: Record<string, any>,
  fields: IField[],
): { [name: string]: any } {
  const properties: { [name: string]: any } = {};

  fields.forEach((field) => {
    const name = field.name || field.alias;
    const attributeValue = attributes[name];

    if (attributeValue !== null && attributeValue !== undefined) {
      switch (field.type) {
        case FieldType.Date:
          properties[name] = new Date(attributeValue).toLocaleString();
          break;

        default:
          properties[name] = attributeValue;
      }
    }
  });

  return properties;
}
